<template>
  <div class="exams-list-page">
    <div class="main-content">
      <HomeTrainingList
        :yearList="yearList"
        :selectedYear="selectedYear"
        :trainingMap="trainingMap"
        :userInfo="curUser"
        :loading="loading"
        :sections="displaySections"
        @year-change="handleYearChange"
        @enroll="handleEnroll"
        @detail="handleDetail"
      />
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";
import HomeTrainingList from "@/views/home/components/HomeTrainingList.vue";

const SECTION_META = {
  0: { majorType: 0, title: "专科培训", color: "#3E74C8" },
  1: { majorType: 1, title: "专项培训", color: "#64C6B0" },
  2: { majorType: 2, title: "专题培训", color: "#D9B03F" },
  3: { majorType: 3, title: "师资培训", color: "#4D6FB2" }
};

export default {
  name: "ExamsList",
  components: {
    HomeTrainingList
  },
  data() {
    return {
      yearList: [],
      selectedYear: new Date().getFullYear(),
      loading: false,
      majorType: 0,
      curUser: null,
      trainingMap: {
        0: [],
        1: [],
        2: [],
        3: []
      }
    };
  },
  computed: {
    displaySections() {
      return [SECTION_META[this.majorType] || SECTION_META[0]];
    }
  },
  created() {
    this.initYearList();
    this.syncMajorTypeFromRoute();
    this.loadInitialData();
  },
  watch: {
    $route() {
      this.syncMajorTypeFromRoute();
      this.loadTrainingDataForYear(this.selectedYear);
    }
  },
  methods: {
    async loadInitialData() {
      await this.loadUserInfo();
      await this.loadTrainingDataForYear(this.selectedYear);
    },
    initYearList() {
      const currentYear = new Date().getFullYear();
      this.yearList = [];
      if (currentYear >= 2020) {
        for (let year = currentYear; year >= 2020; year--) {
          this.yearList.push(year);
        }
      } else {
        for (let year = currentYear; year <= 2020; year++) {
          this.yearList.push(year);
        }
      }
      this.selectedYear = this.yearList[0];
    },
    syncMajorTypeFromRoute() {
      const queryType = Number(this.$route.query.majorType);
      if ([0, 1, 2, 3].includes(queryType)) {
        this.majorType = queryType;
        return;
      }

      const routePath = this.$route.path || "";
      if (routePath.includes("examsListzx")) {
        this.majorType = 1;
      } else if (routePath.includes("examsListzt")) {
        this.majorType = 2;
      } else if (routePath.includes("examsListsz")) {
        this.majorType = 3;
      } else {
        this.majorType = 0;
      }
    },
    async loadUserInfo() {
      const res = await httpRequest("/app/user", "get", null);
      if (res && res.code === 200) {
        this.curUser = res.data || null;
      }
    },
    async loadTrainingDataForYear(year) {
      this.loading = true;
      try {
        const res = await httpRequest("/app/exam/exam/can-enroll-exams", "get", {
          majorType: this.majorType,
          year
        });
        const list = res && res.code === 200 && Array.isArray(res.data) ? res.data : [];
        const nextMap = { 0: [], 1: [], 2: [], 3: [] };
        nextMap[this.majorType] = list;
        this.trainingMap = nextMap;
      } finally {
        this.loading = false;
      }
    },
    handleYearChange(year) {
      if (year === this.selectedYear) {
        return;
      }
      this.selectedYear = year;
      this.loadTrainingDataForYear(year);
    },
    handleEnroll(row) {
      const userToken = localStorage.getItem("pc_user_token");
      if (!userToken) {
        this.$message.warning("请先登录");
        this.$router.push("/login");
        return;
      }
      this.$router.push({
        path: "/registrationDetails",
        query: {
          erId: row.erId,
          isXQ: "0"
        }
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/registrationDetails",
        query: {
          erId: row.erId,
          isXQ: "1"
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.exams-list-page {
  min-height: calc(100vh - 77px - 100px);
  background-color: #f2f4f8;
  padding-top: 20px;
  padding-bottom: 40px;

  .main-content {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>
